// Company address supplied by Gary Byrnes, 24 September 2026.
// Reuse across Tao Climate product updates. This does not amend external registries.
export const COMPANY_ADDRESS = "156 Whitecliff, Dublin D16 WC59";
export const COMPANY_POSTAL_ADDRESS = {
  "@type": "PostalAddress", streetAddress: "156 Whitecliff",
  addressLocality: "Dublin", postalCode: "D16 WC59", addressCountry: "IE",
};
